<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="">
    <div class="font-gotham-bold">
      <ul role="list" class="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer">
          <div
            @click="handleClickAddHardwareProduct"
            class="transition duration-250 border-solid"
            :class="[(hardwareProductAdded ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-xl transition duration-250 text-black" :class="[hardwareProductAdded ? 'text-black' : 'text-black']">Yes</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
              <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none" :class="[ hardwareProductAdded ? 'text-black' : 'text-black' ]">
                <CheckCircleIcon v-if="hardwareProductAdded" class="w-10 h-10" aria-hidden="true" />
              </button>
            </div>
          </div>
        </li>
        <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer">
          <div
            @click="handleClickRemoveHardwareProduct"
            class="transition duration-250 border-solid"
            :class="[(!hardwareProductAdded ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-xl transition duration-250 text-black" :class="[ !hardwareProductAdded ? 'text-black' : 'text-black' ]">No</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
              <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none"
                :class="[ !hardwareProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
                <CheckCircleIcon v-if="!hardwareProductAdded" class="w-10 h-10" aria-hidden="true" />
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="hardwareProductAdded">
        <h2 class="mt-6 text-brand-secondary text-md font-medium uppercase tracking-wide">Select a Modem</h2>
        <div class="mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4">
          <HardwareSelectorProduct
            v-for="product in products"
            @handle-select-product="handleSelectProduct"
            :product="product"
            :key="product.name"
            :isSelectedProduct="isSelectedProduct(product)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

import { defineProps, defineEmits, ref } from 'vue';
import HardwareSelectorProduct from './HardwareSelectorProductOld.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

const props = defineProps<{
  products: Array<Product>,
  isHardwareAdded: boolean,
  selected: string
}>();

const emit = defineEmits<{(e: 'onHardwareSelected', id: string): void, (e: 'onHardwareToggled', isVoipAdded: boolean): void}>();

const hardwareProductAdded = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddHardwareProduct = () => {
  hardwareProductAdded.value = true;
  emit('onHardwareToggled', true);
};

const handleClickRemoveHardwareProduct = () => {
  hardwareProductAdded.value = false;
  emit('onHardwareToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onHardwareSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};

</script>
